<template>
  <div class="header">
    <el-header>
      <div class="title" @click="go()">首页</div>
      <div @click="logout()" class="logout">退出登录</div>
    </el-header>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    logout() {
      // this.$auth.logout();
      this.$router.push({ path: "/" });
    },
    go(){
      this.$router.replace({ path: "/home/productlist" });
    }
  },
};
</script>

<style lang="scss" scoped>
.header {
  .el-header {
    background: #409eff;
    color: #fff;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    .title {
      width: 300px;
      font-size: 24px;
    }
    .logout {
      width: 100px;
    }
  }
}
</style>
